"use client";
import { solveChallenge as f } from "altcha-lib";
import { useRef as h, useCallback as s, useEffect as m } from "react";
const g = {
  getSolution: async () => {
  },
  prefetchSolution: () => {
  },
  invalidateSolution: () => {
  }
}, u = async (n) => {
  try {
    const t = await fetch(n, {
      method: "GET"
    });
    if (!t.ok)
      throw new Error(`Failed to fetch challenge: ${t.statusText}`);
    const e = await t.json(), { challenge: o, algorithm: r, salt: a, maxnumber: c } = e, { promise: l } = await f(
      o,
      a,
      r,
      c
    ), i = await l || void 0;
    if (!i)
      throw new Error("Challenge not solved");
    return { number: i.number, ...e };
  } catch (t) {
    console.error("Error solving captcha:", t);
  }
}, v = ({
  fetchUrl: n,
  shouldBypassCaptcha: t = !1,
  shouldMakeInitialRequest: e = !0
}) => {
  if (t)
    return g;
  const o = h(null), r = s(() => {
    o.current || (o.current = u(n));
  }, [n]), a = s(async () => {
    let l = await o.current;
    return l || (o.current = u(n), l = await o.current), o.current = null, l;
  }, [n]), c = s(() => {
    o.current = null;
  }, []);
  return m(() => {
    e && r();
  }, [r, e]), {
    getSolution: a,
    prefetchSolution: r,
    invalidateSolution: c
  };
};
export {
  u as fetchAndSolveChallenge,
  v as useCaptcha
};
